export const INVALID_CREDENTIALS = 6053;
export const WEBAUTHN_ASSERTION_FAILED = 7044;
export const ACCOUNT_LOCKED = [6044, 6028];
export const ACCOUNT_INACTIVE = 6041;
export const PASSWORD_EXPIRED = 6091;
export const INVALID_CAPTCHA = [6050, 6051, 6052];
export const INVALID_FIELD = 6004;
export const EMAIL_USED = 6017;
export const MFA_INVALID = 6064;
export const MFA_MAX_ATTEMPTS = 6066;
export const INVALID_RESET_PASSWORD_TOKEN = 6023;
export const INCORRECT_PASSWORD_CHOSEN = 6030;
export const OTP_INVALID = 6064;
export const OTP_EXPIRED = 6067;
export const OTP_MAX_ATTEMPTS = 6066;
export const DENIED_IOVATION_RESPONSE = 6140;
